export const tabbableElements = {
  TEXT_INPUT: 'textInput',
  SUBMIT_BTN: 'submitBtn',
  SKIP_BTN: 'skipBtn',
  YES_BTN: 'yesBtn',
  NO_BTN: 'noBtn',
};

